import $ from 'jquery';

function initCustomAccordion(){
    const $accodrionselector = $("[data-accordion-item]");
    let $accordionsections = $accodrionselector.find("[data-tab-content]");
    if( $accordionsections ) {
        let accordion = $accodrionselector;
        accordion.foundation();
    }
}


export default initCustomAccordion;

